import { render, staticRenderFns } from "./MBFooterInfo.vue?vue&type=template&id=919217ec&scoped=true"
var script = {}
import style0 from "./MBFooterInfo.vue?vue&type=style&index=0&id=919217ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "919217ec",
  null
  
)

export default component.exports